import {NegativeInformation} from 'components/service/loan.types';
import {ProductStatus} from 'components/service/product.types';
import {DictEntry} from 'dictionary/DictionaryType';
import nxModule from 'nxModule';
import templateUrl from 'components/customer/loans/new-loan/page/details/negative-information/negative-information.template.html';
import {Dict} from 'shared/common/dict.types';

class NegativeInformationController {

  protected negativeInformation!: NegativeInformation;
  protected editMode!: boolean;
  protected negativeInformationTypes!: DictEntry[];
  protected loanStatus!: ProductStatus;

  constructor(private dict: Dict) {
  }

  async $onInit(): Promise<void> {
    await this.dict.onLoadingCompleteAsync();
    const negativeInformation = <DictEntry[]> this.dict['LOAN_NEGATIVE_INFORMATION'];
    const foreclosureEntry = negativeInformation.find(de => de.code === 'FORECLOSURE');
    this.negativeInformationTypes = this.loanStatus === 'ROPA' && foreclosureEntry ? [foreclosureEntry] : negativeInformation;
  }

  isEditModeEnabled(): boolean {
    return this.editMode;
  }
}

nxModule.component('negativeInformation', {
  templateUrl,
  bindings: {
    formNi: '=',
    editMode: '<',
    negativeInformation: '=',
    loanStatus: '<'
  },
  require: {
    form: '?^form',
  },
  controller: NegativeInformationController
});


